const SubscriptionModelsRouterConstants = {
    TEMPLATES_ROUTE: 'web-subscription-models/templates/',
    CONFIGURATION_ROUTE: 'ib-subscription-models-configuration-view.html',
    PAYMENT_ROUTE: 'ib-pmt-view.html',
    CONFIRMATION_ROUTE: 'ib-pmt-subscription-models-confirmation-view.html',
    ERROR_ROUTE: 'ib-subscription-models-generic-error-view.html',
    PAGES_URL: {
        SUBSCRIPTIONMODELS_CONFIGURATION: '/PLAPAX',
        SUBSCRIPTIONMODELS_ERROR: '/error',
        SUBSCRIPTIONMODELS_PAYMENTS: '/PLPURCO',
        SUBSCRIPTIONMODELS_CONFIRMATION: '/PLBKCFO'

    }
};
angular.module('ib-subscription-models-routing-module').constant('SubscriptionModelsRouterConstants', SubscriptionModelsRouterConstants);

type SubscriptionModelsRouterConstants = typeof SubscriptionModelsRouterConstants;
